/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MyCalendarDto } from './myCalendarDto.schema';

export const IReadOnlyListOfMyCalendarDto = zod.array(zod.lazy(() => MyCalendarDto));

export type IReadOnlyListOfMyCalendarDto = zod.input<typeof IReadOnlyListOfMyCalendarDto>;
export type IReadOnlyListOfMyCalendarDtoOutput = zod.output<typeof IReadOnlyListOfMyCalendarDto>;
